<template>
  <section>
    <template v-if="showLoader">
      <v-row>
        <v-col cols="12" md="4" lg="4" xl="4" v-for="n in 3" :key="`card-loader-${n}`">
          <v-skeleton-loader class="mb-6" type="card-avatar, article"></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>
    <template v-if="courses != null && showLoader == false">
      <div class="courses">
        <v-row>
          <template v-for="(item) of courses">
            <v-col cols="12" md="4" lg="4" xl="4" :key="`cours_${item._id}`">
              <v-hover v-slot:default="{hover}">
                <v-card
                  class="hoverable card-growable"
                  :height="400"
                  :elevation="hover?6:2"
                  ripple
                  @click="navigate(item)"
                >
                  <v-img
                    class="grey"
                    max-width="100%"
                    width="auto"
                    height="200px"
                    :src="item.image"
                    :lazy-src="item.image"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-card-subtitle class="subtitle-2 pb-3" v-text="item.categories[0].title"></v-card-subtitle>
                  <div
                    style="max-height:72px;overflow-y:hidden;"
                    class="body-2 py-0 px-4"
                    v-text="item.title"
                  ></div>

                  <v-card-text>
                    <v-divider class="my-3"></v-divider>
                    <div class="d-flex">
                      <div>
                        <v-rating
                          half-increments
                          half-icon="fas fa-star-half-alt"
                          background-color="grey"
                          color="amber"
                          readonly
                          dense
                          small
                          :value="item.rating"
                        ></v-rating>
                      </div>
                      <div class="flex-grow-1">
                        (
                        <span v-text="item.rating"></span>
                        )
                      </div>
                      <div class="text-right">
                        <v-icon small class="mr-2 fa-fw">far fa-comments-alt</v-icon>
                        <span>{{ item.countComment }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </template>
          <template v-if="courses.length == 0">
            <v-col cols="12">
              <v-alert text type="info" prominent icon="far fa-sad-tear">
                <div class="display-1">Oops !</div>
                <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
                <p>We don't have course to display</p>
              </v-alert>
            </v-col>
          </template>
        </v-row>
        
        <!-- <div class="d-flex mt-4">
          <div class="flex-shrink-1">
            <v-btn :disabled="currentPage == 1 " @click="onChangePage(-1)">
              <v-icon left>far fa-chevron-left</v-icon>Previous
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <div class="flex-shrink-1">
            <v-btn @click="onChangePage(1)" :disabled="courses.length == 0">
              Next
              <v-icon right>far fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </div> -->
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: "course_renderer",
  props: ["courses", "itemsPerPage", "showLoader", "page"],
  data: () => ({
    currentPage: 1,
    defaultItemsPerPage: 12
  }),
  watch: {},
  computed: {
    itemsPerPageProp() {
      if (this.itemsPerPage != null) {
        return this.itemsPerPage;
      } else {
        return this.defaultItemsPerPage;
      }
    },
    totalPage() {
      if (this.courses != null) {
        return this.courses.length;
      }
      return 1;
    },
    totalVisible() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return 5;
      } else {
        return 10;
      }
    }
  },
  mounted() {
    this.currentPage = parseInt(this.page);
  },
  methods: {
    onChangePage(val) {
      let nextPgae = this.currentPage + val;
      nextPgae = nextPgae < 1 ? 1 : nextPgae;
      this.$emit("update:page", nextPgae);
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id
        }
      });
    }
  }
};
</script>